import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
  getPropertiesSuccess,
  getPropertiesFailure,
  getPropertySuccess,
  getPropertyFailure,
} from './actions';
import {
  GET_PROPERTIES,
  GET_PROPERTY,
} from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

// Get Properties
function* getPropertiesSaga() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/GetpropertyDashboard`, options);
    yield put(getPropertiesSuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getPropertiesFailure(message));
  }
}

// Get Property
function* getPropertySaga({ payload: { propertyId } }) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/Loan/Getproperty/${propertyId}`, options);
    yield put(getPropertySuccess(response));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = (error.description || 'An unknown error occurred');
    }
    yield put(getPropertyFailure(message));
  }
}

/**
 * Watchers
 */
export function* watchGetProperties() {
  yield takeEvery(GET_PROPERTIES, getPropertiesSaga);
}
export function* watchGetProperty() {
  yield takeEvery(GET_PROPERTY, getPropertySaga);
}

function* PropertySaga() {
  yield all([
    takeEvery(GET_PROPERTIES, getPropertiesSaga),
    takeEvery(GET_PROPERTY, getPropertySaga),
  ]);
}

export default PropertySaga;
